import React from 'react';

interface CompanyBasicInfoProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export const CompanyBasicInfo: React.FC<CompanyBasicInfoProps> = ({ formData, handleChange }) => {
  return (
    <div className="form-section">
      <h3>Basic Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="name">Company Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="company_number">Company Number *</label>
          <input
            type="text"
            id="company_number"
            name="company_number"
            value={formData.company_number}
            onChange={handleChange}
            required
            placeholder="e.g., EC001"
            className="form-control"
            title="This will be used as prefix in invoice numbers"
          />
        </div>
        <div className="form-group">
          <label htmlFor="legal_form">Legal Form</label>
          <input
            type="text"
            id="legal_form"
            name="legal_form"
            value={formData.legal_form}
            onChange={handleChange}
            placeholder="e.g., GmbH, Ltd, Inc"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="language">Default Language</label>
          <select
            id="language"
            name="language"
            value={formData.language}
            onChange={handleChange}
            className="form-control"
          >
            <option value="en">English</option>
            <option value="de">Deutsch (German)</option>
            <option value="pt">Português (Portuguese)</option>
            <option value="pt-BR">Português (Brasil)</option>
          </select>
        </div>
      </div>
    </div>
  );
};